import { EPositionType, mapApiPositionTypeToEnum } from '@aqx-core/common/services/dealer';
import { socketService } from '@aqx-core/common/socket';
import { EDealerMessageType, IDealerExposureMessage, TDealerTopicMessage } from '@aqx-core/common/socket/topics/dealer';

export interface IDealerExposureData {
  symbol: string;
  type: EPositionType;
  volume: number;
  lotSize: number;
  units: number;
  entryPrice: number;
  latestTradeTime: number;
}

class DealerTopicSubscription {
  public subscribe = (
    symbol: string,
    subscriptionKey: string,
    onDealerExposure: (dealerExposure: IDealerExposureData) => void
  ) => {
    socketService.topics().dealer.subscribe({
      symbol: symbol,
      receiver: {
        subscriptionKey,
        payload: (payload: TDealerTopicMessage | undefined) => {
          this.dealerTopicReceiver(payload, onDealerExposure);
        }
      }
    });
  };

  public unsubscribe = (
    symbol: string,
    subscriptionKey: string,
    onDealerExposure: (dealerExposure: IDealerExposureData) => void
  ) => {
    socketService.topics().dealer.unsubscribe({
      symbol: symbol,
      receiver: {
        subscriptionKey,
        payload: (payload: TDealerTopicMessage | undefined) => {
          this.dealerTopicReceiver(payload, onDealerExposure);
        }
      }
    });
  };

  private dealerTopicReceiver = (
    payload: IDealerExposureMessage | undefined,
    onDealerExposure: (dealerExposure: IDealerExposureData) => void
  ) => {
    if (payload && payload.M === EDealerMessageType.DEALER_EXPOSURE) {
      onDealerExposure(this.massagePayload(payload));
    }
  };

  private massagePayload = (payload: IDealerExposureMessage) => {
    const { D: data } = payload;

    return {
      symbol: data.S,
      type: mapApiPositionTypeToEnum(data.T),
      volume: data.V,
      lotSize: data.LS,
      units: data.U,
      entryPrice: data.EP,
      latestTradeTime: data.LT
    };
  };
}

export const dealerTopicSubscription = new DealerTopicSubscription();
